import { ResponseSuccess, WalletResponse } from 'TYPES/api.body';
import { ResponseContent } from 'TYPES/response.types';
import {
  CONVERT_POINTS_TO_NAIRA,
  FUND_MADINA_WALLET,
  GET_WALLET_BALANCE,
  GET_WALLET_HISTORIES,
  POINT_NAIRA_EQUIVALENCE
} from '../config/endpoints';
import api from '../config/setAuthHeader';

export const getWalletBalance = async (): Promise<ResponseContent<ResponseSuccess<WalletResponse>>> => {
  return await api.get(GET_WALLET_BALANCE);
};

export type WalletHistoryEntry = {
  id: string;
  type: 'credit' | 'debit';
  amount: number;
  title: string;
  description: string;
  status: string;
  balanceBefore: number | null;
  balanceAfter: number | null;
  reference: string;
  createdAt: string;
};

const asNumber = (value: unknown) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const asText = (value: unknown) => (value == null ? '' : String(value));

const readHistoryRows = (payload: unknown): unknown[] => {
  if (Array.isArray(payload)) return payload;
  if (!payload || typeof payload !== 'object') return [];
  const record = payload as Record<string, unknown>;
  const nested = record.histories ?? record.transactions ?? record.content ?? record.data;
  return Array.isArray(nested) ? nested : [];
};

const toHistoryEntry = (row: unknown, index: number): WalletHistoryEntry => {
  const record = (row && typeof row === 'object' ? row : {}) as Record<string, unknown>;
  const typeText = asText(record.type ?? record.transactionType ?? record.transaction_type).toLowerCase();
  const balanceBefore = record.balance_before ?? record.balanceBefore;
  const balanceAfter = record.balance_after ?? record.balanceAfter;

  return {
    id: asText(record.id ?? record.reference) || String(index),
    type: typeText.includes('debit') ? 'debit' : 'credit',
    amount: asNumber(record.amount ?? record.balance ?? record.points),
    title: asText(record.title ?? record.description) || 'Wallet movement',
    description: asText(record.description),
    status: asText(record.status),
    balanceBefore: balanceBefore == null || balanceBefore === '' ? null : asNumber(balanceBefore),
    balanceAfter: balanceAfter == null || balanceAfter === '' ? null : asNumber(balanceAfter),
    reference: asText(record.reference),
    createdAt: asText(record.created_at ?? record.createdAt ?? record.transactionDate)
  };
};

export const getWalletHistories = async (
  page: number
): Promise<{ rows: WalletHistoryEntry[]; total: number }> => {
  const response = await api.get(GET_WALLET_HISTORIES, {
    params: page > 0 ? { page } : undefined
  });
  const body = (response.data ?? {}) as Record<string, unknown>;
  const payload = body.data ?? body;
  const rows = readHistoryRows(payload).map(toHistoryEntry);
  const metaSource =
    body.meta ??
    (payload && typeof payload === 'object' ? (payload as Record<string, unknown>).meta : undefined);
  const meta = (metaSource && typeof metaSource === 'object' ? metaSource : {}) as Record<string, unknown>;
  const total = asNumber(meta.total) || rows.length;

  return { rows, total };
};
export const v1postfundwallet = async (payload: { amount: number; callback_url: string }) => {
  const { data } = await api.post(FUND_MADINA_WALLET, payload);
  return data;
};

export const getWalletFundStatus = async (reference: string) => {
  const { data } = await api.get(`${FUND_MADINA_WALLET}/status`, { params: { reference } });
  return data;
};

export const convertPointsToNaira = async (points: number) => {
  return await api.post(CONVERT_POINTS_TO_NAIRA, { point: points });
};

export const getPointNairaEquivalent = async (points: number) => {
  return api.get(POINT_NAIRA_EQUIVALENCE.concat(points.toString()));
};
